import { useState } from 'react';
import {
    GlobalContainer,
    ContentContainer,
    ReportContainer,
    TitleContainer,
    Title,
    Subtitle
} from '../styles';
import AlertIcon from '../../assets/alert_icon2.png';
import { today, formatDateTime } from '../../utils';
import ReportInputDataIntervalAgencyUnit from '../../Components/ReportInputDataIntervalAgencyUnit'
import ModalWarn from '../../Components/Modal/Warn/index'

export default function ServicesByAgencyUnitAdminReport(props) {
    const [dataInterval, setDataInterval] = useState({ dt_inicio: "", dt_fim: today() });
    const [selectedAgency, setSelectedAgency] = useState({ value: "", label: "Todos" });
    const [selectedUnit, setSelectedUnit] = useState({ value: "", label: "Todas" })
    const [loadingReport, setLoadingReport] = useState(false);
    const [result, setResult] = useState();
    const [searchError, setSearchError] = useState(false);
    const [searchErrorMessage, setSearchErrorMessage] = useState("");
    const [modalInvalidSessionError, setModalInvalidSessionError] = useState(false)
    const [modalInvalidSessionErrorTitle, setModalInvalidSessionErrorTitle] = useState(null)
    const [modalInvalidSessionErrorMsg, setModalInvalidSessionErrorMsg] = useState(null)

    const user = JSON.parse(localStorage.getItem('user'));

    const onSubmitSearch = async () => {
        setLoadingReport(true);
        setSearchError(false);

        const requestOptions = {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'authorization': user ? user.token : "",
                'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined //Necessário para a validação de acesso à unidade no VerifyAccess.js
            }),
            body: JSON.stringify({
                cpf_gestor: user ? user.cpf_atendente : "",  //Neste caso, o cpf_atendente se refere ao gestor que está gerando o relatório
                codigo_orgao: selectedAgency.value,
                codigo_unidade: selectedUnit.value,
                dt_inicio: dataInterval.dt_inicio,
                dt_fim: dataInterval.dt_fim
            }),
        };

        await fetch(`${process.env.REACT_APP_API_URL}/gestao/relAtendimentosPorOrgaoUnidade`, requestOptions).then(
            function (response) {
                if (response.ok) {
                    response.json().then(function (data) {
                        const groupedData = {};
                        const groupedTotal = {};
                        // eslint-disable-next-line array-callback-return
                        data.map((row, i) => {
                            const orgao = row["NOME_REDE_ATENDIMENTO"];
                            if (!groupedData[orgao]) {
                                groupedData[orgao] = [];
                            }
                            groupedData[orgao].push(row);
                        })
                        setResult(groupedData);
                        Object.entries(groupedData).map(([orgao, unidades, i]) => {
                            if (!groupedTotal[orgao]) groupedTotal[orgao] = {}
                            let qtdeAtendConcluidos = 0;
                            let qtdeAtendNaoConcluidos = 0;
                            unidades.map((r, i) => {
                                qtdeAtendConcluidos = qtdeAtendConcluidos + Number(r.QTDE_ATENDIMENTO_CONCLUIDOS || 0);
                                qtdeAtendNaoConcluidos = qtdeAtendNaoConcluidos + Number(r.QTDE_ATENDIMENTO_NAO_CONCLUIDOS || 0);
                                return null;
                            });
                            groupedTotal[orgao].qtdeAtendConcluidos = qtdeAtendConcluidos;
                            groupedTotal[orgao].qtdeAtendNaoConcluidos = qtdeAtendNaoConcluidos;
                            return null;
                        });
                    });
                } else if (response.status === 422) {
                    response.json().then(function (data) {
                        setSearchError(true);
                        if (!!data.errorCode && !!data.messages) {
                            setSearchErrorMessage(data.messages[0].message);
                        } else if (!!data.errorCode && !!data.message) {
                            setSearchErrorMessage(data.message);
                        } else {
                            // inserir mensagem genérica
                            setSearchErrorMessage('Houve algum problema no servidor.');
                        }
                    });
                } else if (response.status === 403) {
                    response.json().then(function (data) {
                      setModalInvalidSessionErrorTitle(data.title ? data.title : null)
                      setModalInvalidSessionErrorMsg(data.message ? data.message : null)
                      setModalInvalidSessionError(true)
                    })
                } else {
                    setSearchError(true);
                    setSearchErrorMessage('Houve algum problema no servidor. Aguarde um momento e tente novamente.');
                }
            }).catch(function (err) {
                console.error('Failed retrieving information', err);
            });

        setLoadingReport(false);
    }
    return (
        <GlobalContainer>
            <ModalWarn
                id='modalWarnalertInvalidSession'
                appear={modalInvalidSessionError}
                title = { modalInvalidSessionErrorTitle }
                text={ modalInvalidSessionErrorMsg ? modalInvalidSessionErrorMsg : 'Este acesso foi transferido para outro dispositivo.'}
                textButton2='Ir para tela inicial'
                actionButton2={() => { 
                    document.getElementById("btnLogout").click();
                }}
            />
            <ContentContainer>
                <TitleContainer>
                    <Title>Número de atendimentos por rede ou unidade de atendimento</Title>
                </TitleContainer>
                <ReportInputDataIntervalAgencyUnit
                    onSubmitSearch={onSubmitSearch}
                    dataInterval={dataInterval}
                    setDataInterval={setDataInterval}
                    selectedAgency={selectedAgency}
                    setSelectedAgency={setSelectedAgency}
                    selectedUnit={selectedUnit}
                    setSelectedUnit={setSelectedUnit}
                    loadingReport={loadingReport}
                    setResult={setResult}
                    result={result}
                    modalError={searchError}
                    setModalError={setSearchError}
                    messageError={searchErrorMessage}
                    history={props.history}
                />
                {(result && Object.entries(result).length > 0) ?
                    <ReportContainer>
                        <Subtitle><label>Relatório extraído em {formatDateTime(Date())}</label></Subtitle>
                        <div className="br-table" data-search="data-search" data-selection="data-selection">
                            {Object.entries(result).map(([orgao, unidades, i]) => (
                                <>                                
                                <table>
                                    <thead>
                                        <tr>
                                            <th colspan="4" className="orgao-header" style={{fontSize: '15px', fontWeight: 'bold' }}>Rede de atendimento: {orgao}</th>
                                        </tr>
                                        <tr>
                                            <th className="unidade-header">Nome da Unidade</th>
                                            <th>Concluídos</th>
                                            <th>Não concluídos</th>
                                            <th>Não permitidos</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {unidades.map((r, i) => (
                                        <tr>
                                            { (r.NOME_UNIDADE && r.DATA_DELECAO) && 
                                                <td style={{color: 'red'}}>{'[Excluído] '  + r.NOME_UNIDADE}</td>
                                            }
                                            { (r.NOME_UNIDADE && !r.DATA_DELECAO) &&
                                                <td style={((r.NOME_UNIDADE === '[Excluída fisicamente]') || r.NOME_UNIDADE === '[Atendimentos sem unidade]') ? {color: 'red'} : {color: ''}}>{r.NOME_UNIDADE}</td>
                                            }
                                            <td>{r.QTDE_ATENDIMENTO_CONCLUIDOS || 0}</td>
                                            <td>{r.QTDE_ATENDIMENTO_NAO_CONCLUIDOS || 0}</td>
                                            <td>{r.QTDE_STATUS_FA || 0}</td>
                                        </tr>
                                        )
                                        )}
                                    </tbody>
                                </table>
                                </>
                            ))}
                        </div>  
                        
                    </ReportContainer>
                    :
                    <>
                        {result && Object.entries(result).length === 0 &&
                            <span className="feedback warning" role="alert" id="listresult">
                                <i className="fas fa-times-circle" aria-hidden="true">
                                    <img
                                        src={AlertIcon}
                                        style={{ paddingBottom: '5px' }}
                                        alt="failicon"
                                    />
                                </i>
                                <label id="listresultlabel">Não existe unidade cadastrada para a rede de atendimento selecionada.</label>
                            </span>
                        }
                    </>
                }

            </ContentContainer>
        </GlobalContainer>
    );
}